import React from 'react';

import {
  faCheck,
  faCircleQuestion,
  faXmark,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import { palette, lightPalette } from '@app/theme';
import { ScrollableTable } from '@components/ui/ScrollableTable';

import { tableHeaderCellSx, zebraRowSx } from '../analysisReport.utilities';

import type { AssessmentTableProperties } from './AssessmentTable.types';
import type { AssessmentStatus } from '@api/aiReviews/api.aiReviews.reviewTypes';


function AssessmentStatusIcon({ status }: { status: AssessmentStatus }) {
  if (status === 'pass') {
    return <FontAwesomeIcon icon={faCheck} style={{ fontSize: 13, color: palette.success.main }} />;
  }
  if (status === 'fail') {
    return <FontAwesomeIcon icon={faXmark} style={{ fontSize: 13, color: palette.error.main }} />;
  }
  return <FontAwesomeIcon icon={faCircleQuestion} style={{ fontSize: 13, color: lightPalette.text.disabled }} />;
}

export const AssessmentTable: React.FC<AssessmentTableProperties> = ({ items, dataTest }) => {
  return (
    <ScrollableTable dataTest={dataTest} ariaLabel='Оценка по критериям'>
      <Table size='small'>
        <TableHead>
          <TableRow>
            <TableCell sx={tableHeaderCellSx}>Критерий</TableCell>
            <TableCell sx={{ ...tableHeaderCellSx, width: 60, textAlign: 'center' }}>Статус</TableCell>
            <TableCell sx={tableHeaderCellSx}>Детали</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((item, index) => (
            <TableRow key={index} sx={zebraRowSx}>
              <TableCell
                sx={{
                  fontSize: 13,
                  fontWeight: 500,
                  color: lightPalette.text.primary,
                  borderBottom: `1px solid ${lightPalette.border.light}`,
                  py: 1.5,
                  px: 2,
                }}
              >
                {item.criterion}
              </TableCell>
              <TableCell
                sx={{
                  borderBottom: `1px solid ${lightPalette.border.light}`,
                  py: 1.5,
                  px: 2,
                  textAlign: 'center',
                }}
              >
                <AssessmentStatusIcon status={item.status} />
              </TableCell>
              <TableCell
                sx={{
                  fontSize: 13,
                  color: lightPalette.text.secondary,
                  borderBottom: `1px solid ${lightPalette.border.light}`,
                  py: 1.5,
                  px: 2,
                }}
              >
                {item.details}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </ScrollableTable>
  );
};
